module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/plainclothesnaked_con#ch_04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FOUR")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("His mother’s ankles felt like hot salamis as Tony Zank held her out the rest home window.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You gonna talk, Ma, or am I gonna have to waggle?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was surprised by how tough she was. And he wasn’t loving swinging her out the fourth floor of Seventh Heaven, where anyone could look up and see he wasn’t exactly running her a sitz bath. The worst part, though, was the view. Mrs. Zank wore nothing under her nightie, and every time Tony looked down he got an eyeful.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Mom-twat,” McCardle said, shaking his Dinoesque head. He’d sidled up to give moral support after tying the ninety-year-old whose room they’d appropriated, a retired osteopath named Fitzer, to the wheelchair bar "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("beside his bathtub. “Not something a boy should ever have to see. My mom used to get drunk and do splits on a pool table, so I oughta know.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Do I need to hear about this?” snarled Zank. “Right this minute?”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Originally,")]), _vm._v(" the idea seemed simple. Once his mom calmed down and crawled back in bed after her trot down the hall, Tony managed to convince the attendants that she’d been having an “episode.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She imagines things,” he’d confided, looking just ashamed enough to make it sound authentic. “It started when my dad hit her with a bowling pin twenty years ago. Today she thought I was trying to steal something from her. That hurts, you know? This is my mother. This lady "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("raised")]), _vm._v(" me. Plus, and tell me if I’m wrong here, there’s nothing in this dump anybody’d want to steal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Carmella, the big Puerto Rican lady in charge, had cut her teeth in Leisure World and seen it all. Her beehive gave her an extra six inches on top, and her hips, though shapely, could have smothered triplets. She was the sort of large woman who celebrated her largeness, accentuating it with doughnut-size hoop earrings and brash magenta lipstick plumping up her lips. She neither replied to Tony’s explanation nor totally ignored him. Not until McCardle popped out of the bathroom waving a jar of thyroid medication, mistaking it for speed, did she slam her palm on the bedpan like a tambourine and pipe up. “You wanna ransack the joint, you gotta pay like everybody else, Gomer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Carmella whipped her hand out to Tony but her eyes stayed fixed on McCardle, who responded with courtly charm.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t believe anyone has ever called me Gomer before. Not many of us Negro fellows get named that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Carmella didn’t bother to reply, but kept her hand extended until Tony warmed it with a pair of twenties.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Just don’t leave stains,” she warned, “and don’t put no cigarettes out on the furniture. The inspector from the state board sees burns on the furniture, he’s gonna think we’re letting residents smoke, which since they tend to nod off—and ain’t allowed to have matches—means all kinda bad news. You got me, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hombres?")]), _vm._v(" Behave your ass in here!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before Tony could even thank her she turned and hurried out.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“You believe that?” he said, checking to make sure his mother was under control. Carmella either hadn’t seen his grip on the old lady’s wrist, or hadn’t cared. “She thinks we don’t know half the staff is bangin’ old guys for pin money. That’s why they hire ’em so young. A smart chick can mop up. Get one of these bum tickers to smoke out in the sack, it’s payday. Any family with dough will cough up. Who wants it gettin’ out Gramps bought the farm goin’ Tommy Lee on some gash whose last job before this was homework?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zank shook his head, then turned on his mother and asked her straight out. “Who’s been sniffin’ around your bed, Ma?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What are you, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("jealous?")]), _vm._v("” she snapped back. “A girl gotta have some fun, even on this crap farm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His mother didn’t talk like this before entering the home. For as long as Zank could remember, she was a mild-mannered, miserable woman who tended to housework and made lunch for the vicious lunk of a husband she’d married at nineteen until he keeled over, under questionable circumstances, when she was forty. Decades later, after a bowling party on her sixty-third birthday, Zank found her passed out on a throw rug with her face in her needlepoint. It turned out she’d been guzzling a quart of gin a day for years and hiding it. The doctor said it was not uncommon. “It’s when they don’t get the stuff that you notice,” he’d explained, before announcing that his mom needed round-the-clock care. He suggested a convalescent home, and the cheapest Tony could find was Seventh Heaven. But since moving in with the other seniors, she’d become a gutter-mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You think you can put the squeeze on me, you’re stupid "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" ugly,” she told her son.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Mom,” Zank pleaded, “how come you’re talkin’ like this? You used to talk nice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mrs. Zank snorted. “You had the good sense to bring a bottle when you visit, we wouldn’t be in this pickle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Genuinely distressed, Tony dropped his mom’s wrist to tap for the Slim Jim in his jacket pocket. In a second she had her fingers around her ashtray, which she kept in a hollowed-out phone book by the bed. It was a brass replica of William Penn, with grooves in his three-cornered hat for butts. And it made a dent in Tony’s forehead like a ball-peen hammer.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Mom, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus!")]), _vm._v("” Tony shrieked. But she was up out of her bed before he could grab her. Lunging for the call button, she thumbed it as she scooted past McCardle, who just managed to nab the tail of her gown.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I could cry rape,” the old lady teased. “You’ve got your paw pretty close to my thingy. They hang your kind for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("McCardle cringed, but Tony smiled. “Maybe he likes you, Ma.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“His type always do,” she said, snatching her walker and whacking the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("America’s Most Wanted")]), _vm._v(" grad across the shins. She smiled saucily, then threw out one exposed old-lady hip, and spanked herself. “You think your father was the only one who wanted a piece of angel cake?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zank was so horrified he zombied up, staring straight ahead in a catatonic daze. McCardle pulled the walker away from his partner’s mother, and when she fought him he tried to punch her. He’d never hit a woman this old before. Despite topping off at five four, he could bench-press 375, and there was a chance he could do damage. McCardle was relieved when she dodged the blow, though it meant that now he had to restrain her. After a brief tussle the feisty senior ended up in a headlock. Not sure what to do next, Mac tried to rouse Tony back to life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Come on, big guy, don’t go Thorazine on me. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wake up!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Nervous lest anyone happen by and see him wrestling an elderly white woman, McCardle edged Tony’s mother away from the door. When he tried to force her onto the bed, she screamed “Mandingo!” and bit him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hey, ouch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shit!")]), _vm._v("” McCardle cried, trying not to get loud when Mrs. Zank started chewing on his forearm. Her teeth were small but pointy, like a Chihuahua’s. He started to pull her hair, but stopped when he saw the frail map of veins under her blue rinse. Her scalp reminded him of his auntie, with her stroke and hygiene problems.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Tony.” Mac tried again, pleading this time, and Zank jerked back to life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We gotta split,” Tony announced, as if he hadn’t just blanked out. “I think the old bitch pressed the call button.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Swinging into action, he scooped his mother under one armpit while McCardle grabbed her under the other.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("“Ready?” Tony asked. McCardle grunted and, eyes straight ahead, the two men stepped out of the room and half-marched, half-dragged ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("Mrs. Zank down the hall. They held their breaths, waiting for her screams. But when they finally dared to look, the old lady was beaming.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Check me out, I’m double-datin’!” she called to Snooks, the janitor, who happened to be pushing by with a floor waxer. Snooks was rumored to have gang connections and deal a little. Dr. Dre leaked out of his earphones and he pretended not to hear anything. One peek at the purple bruise on Tony Zank’s forehead, and the face of the semi-naked crazy lady, and he made a point of waxing fast toward the other end of the corridor.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When Snooks passed, Mrs. Zank waved happily to a well-coifed woman in a wheelchair. She even winked. “Don’t wait up, Hilda. Tonight’s sandwich night!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The wheelchair woman just stared, and McCardle and Zank tried hard not to look at each other. A flutey voice on the PA said, “All staff report to Fourth Floor West.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("we")]), _vm._v(" are,” Tony hissed. “Duck in here!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They tooled into what looked like an empty room, and it wasn’t until Mac turned on a lamp that they noticed the unbelievably old man propped on a wicker rocker.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Have I had the pleasure?” the ancient fellow piped up, his voice a surprising baritone. He managed to look elegant in a pair of shorty pajamas. “Name’s Fitzer. In my time, I was known as a first-class osteopath. My motto is ‘Bones make the man!’”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Bathroom,” was all Zank said, and McCardle nodded. He had the well-heeled senior tied up and gagged with a fistful of Tucks when Tony hung his mother out the window.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Mom, you ready to spill?” Tony called to her. He hated the way her ankles felt in his hands and wished he’d thought to bring gloves. Of course, he hadn’t known he was going to be dangling his mother upside down. If he had, he would have made her wear underwear….")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll spill,” she cried up at him. “I’ll spill the beans on what a little milk-pussy you were as a boy, that’s what I’ll spill, you good-for-nothing drug addict.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("McCardle fought hard to keep his face in neutral. He was impressed at the way Tony kept his cool. He didn’t know what he’d do if his own moms shamed him that way. Happily, she wouldn’t be out before 2039, so it wasn’t an issue.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“All I want is a name, Ma. I want to know who had access to the bed. That’s it. Then I’ll let you go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Your father never messed around. Did you know that?” his mother shrieked. Not once! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The idiot!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tony’s jaw began to twitch. He hadn’t had any crack for twenty minutes, and it was killing him. He swung his mom so her head crunched off the ivy crawling up the wall. Then he leaned out the window and called down to her. “I hate when you talk nasty, Ma. You didn’t used to do that. You used to whine all the time, but you didn’t talk nasty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Fell in with the wrong crowd,” she yelled. “You dump somebody in this bone factory, they’re gonna get wrong pretty fast. Everybody in here’s pissed off, ’specially us boozehounds.” The effort of speaking upward was taxing, and she let herself sag. “All we got to slurp in here is mouthwash.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By now, people were starting to gather in the plaza under the window. McCardle couldn’t watch and decided to check on the osteopath.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Okay,” Mrs. Zank cackled finally. “I saw the girl who took your precious envelope. Her name’s Tina, but she’d never go out with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you.")]), _vm._v(" She hates losers. She likes her sugar with class. We talked.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Mom,” Tony sighed, but quieter than before, like he didn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("want")]), _vm._v(" to say what he was about to say, but he just "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" to. He didn’t have a choice. It was something he’d once heard on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr. Laura.")]), _vm._v(" “Mom, when you hurt me this way, I have to let you go with love….”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("McCardle,")]), _vm._v(" who’d popped back out of the bathroom after peeking in on Fitzer, could not quite believe what had happened. At first, hearing the screams and shouting from outside, he told himself that maybe a celeb was visiting. Tony had bragged that Joey Bishop sometimes dropped in to Seventh Heaven to visit his older brother, Rummy. But he couldn’t imagine the seventy-plus, second-tier Rat Packer getting those kinds of screams.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("“We better go,” Tony said, slipping a Slim Jim out of his pocket and sniffing it. He had a theory that they made them in batches, like cigars, and some were more vintage than others. “We wanna get painadelic ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("on this Tina chick, we gotta get there before she thinks anybody’s comin’.”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Right,” said McCardle, but as they were leaving, he kept checking the room. One minute Mrs. Zank’s scarlet toenails were poking over the windowsill, the next Tony was walking toward the door, unwrapping a beef stick.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I wish I hadn’t seen between her legs,” was all Tony said on the way out.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("McCardle didn’t mention that he agreed with him. Or that a guy who nibbled Slim Jims after dropping his mother out a fourth-floor window might need a little therapy himself.")])])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50a878f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plainclothesnaked_ch04.vue
// module id = 84
// module chunks = 0